{
  "order": ["development", "test", "production"],
  "profiles": {
    "development": {
      "label": "Development",
      "shortLabel": "DEV",
      "url": "http://127.0.0.1:3000/",
      "project": "asymmetric-dev-20260821",
      "dataBoundary": "Development Firestore",
      "operationPolicy": "Editable source and development data; real orders disabled"
    },
    "test": {
      "label": "Test",
      "shortLabel": "TEST",
      "url": "http://127.0.0.1:3100/",
      "project": "local-test",
      "dataBoundary": "Local D1 and process-local fixtures",
      "operationPolicy": "Local validation only; cloud API, external AI, and real orders disabled"
    },
    "production": {
      "label": "Production",
      "shortLabel": "PROD",
      "url": "https://assymetric.online/",
      "project": "asymmetric-capital-20260810",
      "dataBoundary": "Production Firestore",
      "operationPolicy": "Hosted owner environment; changes require an explicit production deploy request"
    }
  }
}
